<span
  #textRef
  class="ws-truncated-text"
  [wsTooltip]="tooltipValue"
  [wsTooltipDisabled]="!tooltipValue"
  [wsTooltipShowDelay]="200"
>
  {{ displayText }}
</span>
